import { render, staticRenderFns } from "./MicCaptureRealTimeSpeechMatics.vue?vue&type=template&id=5b3764be"
import script from "./MicCaptureRealTimeSpeechMatics.vue?vue&type=script&lang=js"
export * from "./MicCaptureRealTimeSpeechMatics.vue?vue&type=script&lang=js"
import style0 from "./MicCaptureRealTimeSpeechMatics.vue?vue&type=style&index=0&id=5b3764be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports